import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "umbraco-forms-field-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxLabel = _resolveComponent("TpxLabel")!
  const _component_TpxTooltip = _resolveComponent("TpxTooltip")!
  const _component_TpxCheckbox = _resolveComponent("TpxCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(_component_TpxLabel, {
          key: 0,
          colour: "white",
          content: _ctx.label,
          isRequired: _ctx.isRequired
        }, null, 8, ["content", "isRequired"]))
      : _createCommentVNode("", true),
    (_ctx.tooltip)
      ? (_openBlock(), _createBlock(_component_TpxTooltip, {
          key: 1,
          tooltip: _ctx.tooltip
        }, null, 8, ["tooltip"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "checkboxes", {}, () => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkboxes, (checkbox) => {
          return (_openBlock(), _createBlock(_component_TpxCheckbox, _mergeProps({
            key: checkbox.id
          }, checkbox, {
            isChecked: checkbox.isChecked,
            "onUpdate:isChecked": ($event: any) => ((checkbox.isChecked) = $event),
            onChange: ($event: any) => (_ctx.$emit('change', checkbox.isChecked = $event))
          }), null, 16, ["isChecked", "onUpdate:isChecked", "onChange"]))
        }), 128))
      ])
    ])
  ], 64))
}